module.exports = __webpack_public_path__ + "img/russia.a99780d1.svg";